import React, { useMemo } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { collected, deliveryCharge, payment, priceReduced } from '../helpers/balanceCalculate';

interface FooterCalculatorProps {
  rows: any[];
  classes: {
    hidePrint: string;
  };
}

export default function FooterCalculator({ rows, classes }: FooterCalculatorProps) {
  const totalTaka = useMemo(() => rows.reduce((a, b) => a + (b.merchant_COD ?? 0), 0), [rows]);
  const damKomeche = useMemo(() => priceReduced(rows), [rows]);
  const ferot = useMemo(() => rows.reduce((a, b) => a + (b.return_product_price ?? 0), 0), [rows]);

  const ferotPending = useMemo(
    () =>
      rows.reduce(
        (a, b) => (b.status === 'RETURNED' && b.merchant_COD !== b.return_product_price ? a + b.merchant_COD : a),
        0,
      ),
    [rows],
  );
  const totalDC = useMemo(() => deliveryCharge(rows), [rows]);
  const totalCollected = useMemo(() => collected(rows), [rows]);
  const totlaPending = useMemo(
    () =>
      rows.reduce(
        (a, b) =>
          ['DELIVERED', 'PARTIALLY_DELIVERED', 'PAYMENT', 'RETURNED'].includes(b.status) ? a : a + b.merchant_COD,
        0,
      ),
    [rows],
  );
  const totalPayment = useMemo(() => payment(rows), [rows]);
  const totalDue = useMemo(() => collected(rows) + deliveryCharge(rows) + payment(rows), [rows]);

  return (
    <>
      <TableRow>
        <TableCell className={classes.hidePrint}></TableCell>
        <TableCell className={classes.hidePrint}></TableCell>
        <TableCell></TableCell>
        <TableCell align="left">টোটাল টাকা</TableCell>
        <TableCell align="left">দাম কমেছে</TableCell>
        <TableCell align="left">ফেরত</TableCell>
        <TableCell align="left">ফেরত পেন্ডিং</TableCell>
        <TableCell align="left">ডি. সি.</TableCell>
        <TableCell align="left">সংগ্রহ</TableCell>
        <TableCell align="left">পেন্ডিং</TableCell>
        <TableCell align="left">পেমেন্ট</TableCell>
        <TableCell align="left">পাবেন</TableCell>
        <TableCell align="center" className={classes.hidePrint}></TableCell>
        <TableCell align="center" className={classes.hidePrint}></TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.hidePrint}></TableCell>
        <TableCell className={classes.hidePrint}></TableCell>
        <TableCell></TableCell>
        <TableCell align="left">{totalTaka}</TableCell>
        <TableCell align="left">
          {/* দাম কমেছে */}
          {damKomeche}
        </TableCell>
        <TableCell align="left">{ferot}</TableCell>
        <TableCell align="left">{ferotPending}</TableCell>
        <TableCell align="left">{totalDC}</TableCell>
        <TableCell align="left">
          {/* সংগ্রহ */}
          {totalCollected}
        </TableCell>
        <TableCell align="left">{totlaPending}</TableCell>
        <TableCell align="left">{totalPayment}</TableCell>
        <TableCell align="left">
          {/* পাবেন */}
          {totalDue}
        </TableCell>
        <TableCell align="center" className={classes.hidePrint}></TableCell>
        <TableCell align="center" className={classes.hidePrint}></TableCell>
      </TableRow>
    </>
  );
}
